'use client';

import { DrawerTrigger } from '@heidi/design-system/drawer';
import { DropdownMenuTrigger } from '@heidi/design-system/dropdown-menu';
import * as React from 'react';

import { VariantContext } from './context';

type AdaptiveMenuTriggerProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  asChild?: boolean;
};

export const AdaptiveMenuTrigger = ({ children, ...props }: AdaptiveMenuTriggerProps) => {
  const variant = React.useContext(VariantContext);
  // DrawerTrigger (vaul) renders a <button>, so `disabled` applies the same way.
  const Trigger = variant === 'menu' ? DropdownMenuTrigger : DrawerTrigger;
  return <Trigger {...props}>{children}</Trigger>;
};
